/* ============================================================
   GOB — one thing at a time (V149, 19 Oct 2026)

   Three overlays could open on top of each other on the first visit:
     1. Tinycookie consent box   (#tinycookie-wrapper)
     2. Choose your store popup  (#gob-geo, gob-geo.js)
     3. TREAT20 "Light the manor" popup (.t20-ov, gob-treat20.js)

   Now they queue: cookie box first, then the store popup, then the
   Halloween popup. Nothing is removed from the other scripts; this only
   hides an overlay (CSS class on <html>) while an earlier one is open.

   GOB Club landing page (/pages/membership): the Halloween popup never
   shows. Visitors there come for the Club, and TREAT20 is not combined
   with the Club anyway.
   ============================================================ */
(function () {
  'use strict';
  if (window.__gobCalm) return; window.__gobCalm = 1;
  var H = document.documentElement;
  var path = location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, '');
  var CLUB = /^\/pages\/membership\/?$/i.test(path);
  if (CLUB) H.classList.add('gc-club');

  function shown(el) {
    if (!el) return false;
    var s = getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden' && el.offsetHeight > 60;
  }
  function cookieOpen() {
    var w = document.getElementById('tinycookie-wrapper');
    if (!w) return false;
    if (shown(w)) return true;
    for (var i = 0; i < w.children.length; i++) if (shown(w.children[i])) return true;
    return false;
  }
  function geoOpen() { return !!document.getElementById('gob-geo'); }

  function update() {
    var c = cookieOpen();
    H.classList.toggle('gc-cookie', c);
    H.classList.toggle('gc-busy', c || geoOpen());
    if (CLUB) { var o = document.querySelector('.t20-ov'); if (o) o.remove(); }
  }

  update();
  var n = 0, iv = setInterval(function () { update(); if (++n > 300) clearInterval(iv); }, 300);
  function watch() {
    try { new MutationObserver(update).observe(document.body, { childList: true }); } catch (e) {}
    document.addEventListener('click', function () { setTimeout(update, 50); setTimeout(update, 400); }, true);
  }
  if (document.body) watch(); else document.addEventListener('DOMContentLoaded', watch);
})();
